<template>
  <div id="Vue-3-component-dropdown-menu">
    <TextInput
        id="inputElement"
        ref="input"
        :label="label"
        :label-top="labelTop"
        :labelWidth="labelWidth"
        v-model="selectedItem"
        :validation-fail="validationFail"
        :validation-text="validationText"
        :requiredField="requiredField"
        @keydown.stop="keyboardSelectItem"
        @click.self="setupClick"
        @wheel="stopScroll"
        :disable="disable"
        :readonly=true
        :width="width"
        @mouseleave="autoCloseSelectResults"
        :placeholder="placeHolder">
      <div
          @click="handleClear"
          v-if="selectedItem && !disable && !removeClearButton"
          class="input-clear-container">
        <div @mouseleave="autoCloseSelectResults" class="input-cross">+</div>
      </div>
      <span
          v-if="!selectedItem && !disable">
            <div id="clickIcon" @mouseleave="autoCloseSelectResults" @wheel="stopScroll" class="input-icon-container"
                 @click="setupClick">
              <span class="input-arrow-down"></span>
            </div>
        </span>
    </TextInput>

    <!--    <div v-if="validationStatus" class="input-validation-message">Required</div>-->

    <div tabindex="0" id="select-results" ref="select" @mouseleave="autoCloseSelectResults" @wheel="scrollItems"
         @mouseenter="reEnterSelect" v-if="showResults === true"
         :class="{'select-item-container' : !popupSelectResults, 'select-item-container-popup' : popupSelectResults}">
      <ul id="results-list" class="select-item-container-list" data-cy="lstDdlResult">
        <li ref="ul" v-for='(item, index) in dataSource' :key='index'
            @click="selectItem(item, index)"
            :class='{"select-highlight-current-row": selected === index}'>
          <div class="select-item-container-data" ref="list">
            <div class="select-list-items" :tabindex="index" ref="listItem">{{ item.text }}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import TextInput from "@/components/common/input/TextInput";
import DropDownItem from "@/classes/component-classes/DropDownItem";
import Validation from "@/classes/global/Validation";


export default {
  name: "DropDownMenu",

  mounted: function () {

    // State - Set prop data from model

    if(this.modelValue) {

      if(typeof this.modelValue === 'object') {
        if(this.modelValue.id) this.selectedItem = this.dataSource.find(x => x.id === this.modelValue.id).text;

      } else {
        this.selectedItem = this.dataSource.find(x => x.id === this.modelValue).text;
      }

    }

  },

  data: function () {
    return {

      selectedItem: '',
      popupSelectResults: this.popupResults ? this.popupResults : this.popupSelectResults === false,
      showResults: false,
      selected: -1,
      closeTimer: null,
      closeTime: 600,

      menuFullOpenHeight: {
        type: Number,
        default: 0
      }

    }
  },
  components: {
    TextInput
  },

  props: {

    modelValue: {},

    dataSource: {
      type: Array,
      default: function () {
        return []
      }
    },

    placeholder: {
      type: String,
      default: 'Select...'
    },
    removeClearButton: {
      type: Boolean,
      default: false
    },
    validationFail: {
      type: Object,
      default: {}
    },
    validationText: {
      type: Array,
      default: ['Required']
    },
    popupResults: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 300
    },

    label: {
      type: String,
      default: ''
    },

    labelTop: {
      type: Boolean,
      default: false
    },

    labelWidth: Number,

    requiredField: {
      type: Boolean,
      default: false
    }

  },

  methods: {

    getSelectResultContainerPosition(popupResults) {

      this.$nextTick(() => {

        let inputElement = this.$refs.input
        let selectDrop = this.$refs.select;

        let inputTopPosition = inputElement.$el.children[1].getBoundingClientRect().top;
        let inputLeftPosition = inputElement.$el.children[1].getBoundingClientRect().left;
        let inputWidth = inputElement.$el.children[1].getBoundingClientRect().width - 2;


        if (selectDrop) {

          let selectHeight = selectDrop.clientHeight + 29;
          this.menuFullOpenHeight = selectHeight

          if (!popupResults) {

            selectDrop.style.cssText = `top: ${inputTopPosition + "px"}; left: ${inputLeftPosition + "px"}; width: ${inputWidth + "px"} `
          } else {

            selectDrop.style.cssText = `top: ${inputTopPosition - selectHeight + "px"}; left: ${inputLeftPosition + "px"}; width: ${inputWidth + "px"} `
          }

        }

      })

    },

    reEnterSelect() {

      // Re add this if overscroll css ever has an issue with the selectbox detaching

      // document.addEventListener("wheel", this.autoCloseSelectResults);
      //
      // if(this.showResults) {
      //   document.removeEventListener("wheel", this.closeResults);
      // }

      document.removeEventListener('wheel', this.closeResults)

      clearTimeout(this.closeTimer);

    },

    autoCloseSelectResults(e) {

      //Measure the mouse position within the menu boundries - close if mouse is out of bounds
      if (this.showResults) {

        let selectDrop = this.$refs.select;

        let selectTop = selectDrop.offsetTop;
        let selectLeft = selectDrop.offsetLeft;
        let selectWidth = selectDrop.getBoundingClientRect().width;

        let selectHeight = selectDrop.clientHeight + 29;

        // Slight difference in value adjustment between popup and normal to stop auto close behaviour bug
        let selectBottom = selectTop + selectHeight - 32;
        let selectBottomPopup = selectTop + selectHeight - 29;



        if (!this.popupSelectResults) {

          if (e.clientX < selectLeft || e.clientX > selectLeft + selectWidth - 10 || e.pageY - window.scrollY < selectTop
              || e.pageY > selectBottom) {

            window.addEventListener("scroll", this.closeResults);
            document.addEventListener("wheel", this.closeResults);
            window.addEventListener('click', this.closeResults)

            // Only close if the menu is fully open
            if (selectHeight === this.menuFullOpenHeight) {

              clearTimeout(this.closeTimer)
              this.closeTimer = setTimeout(() => this.closeResults(), this.closeTime);

            }
          }

        } else {

          if (e.clientX < selectLeft || e.clientX > selectLeft + selectWidth - 10 || e.pageY < selectTop
              || e.pageY > selectBottomPopup) {

            window.addEventListener("scroll", this.closeResults);
            document.addEventListener("wheel", this.closeResults);

            if (selectHeight === this.menuFullOpenHeight) {

              clearTimeout(this.closeTimer)
              this.closeTimer = setTimeout(() => this.closeResults(), this.closeTime);
              this.selected = -1;
            }

          }

        }

      }
    },

    setupClick(e) {

      // Make the select popup if the input is so far down the screen

      this.popupSelectResults = false;
      let lowerScreenArea = window.outerHeight / 1.3

      if (e.screenY > lowerScreenArea) {

        this.popupSelectResults = true;
      }

      this.showResults = true;
      this.getSelectResultContainerPosition(this.popupSelectResults);

    },

    stopScroll(e) {
      if (this.showResults) e.preventDefault();
    },

    scrollItems(e) {
      e.preventDefault();

      if (e.deltaY > 0) {
        this.$refs.select.scrollBy(0, 22)

      } else {
        this.$refs.select.scrollBy(0, -22)
      }

    },

    closeResults() {
      this.showResults = false;
      this.selected = -1;

      window.removeEventListener('scroll', this.closeResults)
      document.removeEventListener('wheel', this.closeResults)
      window.removeEventListener('click', this.closeResults)
    },


    selectItem(itemSelected, index) {
      this.selectedItem = this.dataSource.find(x => x.id === itemSelected.id).text;
      this.showResults = false;
      this.selected = index;
      this.selected = -1;
      this.$emit('update:validationFail', new Validation(0, false));
      this.$emit("update:modelValue", itemSelected);
    },

    handleClear() {
      this.showResults = false;
      this.selectedItem = "";
      this.selected = -1;
      this.$emit("update:modelValue", new DropDownItem());
      this.$emit('update:validationFail', new Validation(0, false));
    },

    keyboardSelectItem(e) {

      // Disable any scrolling of outside div during keyboard selection
      if (e.key !== 'Tab') {
        e.preventDefault()
      } else {
        this.showResults = false;
      }

      if (e.key === ' ') this.setupClick(e)

      this.$emit('keydown', e);

      if (e.key === 'Backspace' && this.selectedItem === "") {
        this.selectedItem = "";
        this.showResults = false;
      }

      if (e.key === 'ArrowUp' || e.key === 'Up') {

        if (this.selected > 0) this.selected--;

        if(this.$refs.ul)
          if (this.$refs.ul.length > 0 && this.selected >= 0) {

            let highlightedSelectionTop = this.$refs.ul[this.selected].getBoundingClientRect().top;
            let selectDropTop = this.$refs.select.getBoundingClientRect().top - 22; // 22 height of highlight bar

            if (highlightedSelectionTop === selectDropTop) {

              // To support IE 9 + this polyfill is required

              // npm install smoothscroll-polyfill --save

              // Add to main.js
              //import smoothscroll from 'smoothscroll-polyfill';
              //smoothscroll.polyfill();

              this.$refs.select.scrollBy(0, -22)

            }

          }

      } else if (e.key === 'ArrowDown' || e.key === 'Down') {

        if (this.selected < this.dataSource.length - 1) this.selected++;

        if (this.$refs.select && this.selected > 11) {
          this.$refs.select.scrollBy(0, 22)

        }

      } else {

        // Check for enter key being pressed and select item
        if (e.key === 'Enter' || e.key === 'Tab') {

          if(this.selected !== -1) {
            this.$refs.input.$el.children[1].blur();

            if (this.selected !== -1) {
              this.showResults = false;
              this.selectedItem = this.dataSource[this.selected].text;
              this.$emit("update:modelValue", this.dataSource[this.selected]);

              this.selected = -1;

            }

          }

        }
      }

    }
  },

  computed: {

    placeHolder() {
      if (this.dataSource) {
        if (this.dataSource.length === 0) {
          return 'No data to display';
        }
      }
      return this.placeholder;
    },

    labelPosition() {
      if (!this.labelTop) {
        return 'label-input-wrapper'
      }
      return '';
    },

    requiredFieldColor() {
      if (this.requiredField) {
        return 'background-color: #ffeda9';
      }
      return '';
    }
  },

  // watch: {
  //
  //   selectedItemId: function () {
  //     if(this.selectedItemId)
  //     this.selectedItem = this.dataSource.find(x => x.id === this.selectedItemId).text;
  //   },
  //
  // }
}

</script>

<style scoped>

/*This was added to prevent other imported css from frameworks breaking the select */
/* May need to be addressed if this causes issues with sharing framework controls */
* {
  box-sizing: revert!important;
}

::-webkit-scrollbar {
  width: 12px;
}

::-webkit-scrollbar-track {
  background-color: #f6f6f6;
}

::-webkit-scrollbar-thumb {
  background: #b3b3b3;
  border-radius: 2px;
}

ul {
  font-size: 12px;
  padding: 0;
}

.input-icon-container {
  position: absolute;
  cursor: pointer;
  right: 2px;
  top: 3px;
  padding-left: 6px;
  height: 20px;
  width: 14px;
  margin-right: 2px;
  background: #d8d8d8;
  border-radius: 4px;
  font-size: 14px;
  line-height: normal;

}

.input-icon-container:hover {
  background-color: #d8d8d8;
  border-radius: 4px;
}

.input-clear-btn {
  position: absolute;
  right: 0;
  /*top: -4px;*/
  padding: 8px;
  z-index: 99;
  font-weight: bolder;
  cursor: pointer;
}

.input-clear-container {
  position: absolute;
  cursor: pointer;
  right: 2px;
  top: 3px;
  padding-left: 6px;
  height: 20px;
  width: 14px;
  margin-right: 2px;
  font-size: 14px;
  line-height: normal;
}

.input-cross {
  position: absolute;
  font-family: Arial;
  transform: rotate(45deg);
  color: #566ea0;
  font-size: 20px;
  right: 5px;
  /*top: 6px;*/
  background: none;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.input-clear-btn:hover {
  opacity: 0.5;
  transition: 0.3s;
}

.input-arrow-down {
  position: absolute;
  top: 7px;
  right: 3px;
  content: "";
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 8px solid #393939;
}

.select-item-container {
  top: 0;
  position: fixed;
  margin-top: 28px;
  z-index: 999999;
  background-color: #fff;
  box-shadow: 1px 1px 4px 0px #888888;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  max-height: 264px;
  overflow-y: scroll;
  overscroll-behavior: contain;
  /*transform-origin: top;*/
  /*transition: transform .2s ease-in-out;*/
}

.select-item-container-popup {
  position: fixed;
  margin-top: 28px;
  z-index: 999999;
  /*bottom: -2px;*/
  /*left: 1px;*/
  /*right: 1px;*/
  background-color: #fff;
  box-shadow: 1px 1px 4px 0px #888888;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  max-height: 263px;
  overflow-y: scroll;
  overscroll-behavior: contain;
  transform-origin: bottom;
  transition: transform .2s ease-in-out;
}

.select-highlight-current-row {
  background-color: #5379ad !important;
  color: #fff;
}

.select-item-container-list {
  list-style: none;
  margin: 0;
  cursor: pointer;

}

.select-item-container-list li {
  height: 20px;
  padding: 2px 0 0 2px;
  line-height: normal;
}

.select-item-container-list li:hover {
  background-color: #dedede;
}

.select-item-container-data {
  display: grid;
  grid-template-columns: 100%;
  padding-top: 2px;
}


/*.fade-enter-active, .fade-leave-active {*/
/*  transition: opacity .2s;*/
/*}*/

/*.fade-enter, .fade-leave-to {*/
/*  opacity: 0;*/
/*}*/

/*.slide-enter {*/
/*  transform: scaleY(0);*/
/*}*/

</style>
